export default "__VITE_ASSET__COPtI5b2__"